import moment from "moment";
import React from "react";
import { TextField } from "shared";
import t from "utils/Lang";
import DatePicker from "react-datepicker";
import _ from "lodash";

type ContractFilterProps = {
  query: any;
  setQuery: any;
};

const ContractFilter = ({ query, setQuery }: ContractFilterProps) => {
  const SeparateItem = () => <div style={{ width: 10 }} />;
  const updateQuery = _.debounce((key, value) => {
    setQuery({ ...query, [key]: value });
  }, 300);
  const onContractCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateQuery("contract_code", event.target.value);
  };
  const onInternalCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateQuery("internal_code", event.target.value);
  };
  const onAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateQuery("site_address", event.target.value);
  };
  return (
    <div className="contract-filter__container">
      <TextField
        style={styles.mt10}
        type="outline"
        placeholder={`${t().site_contract_modal__contract_number}...`}
        icon="search"
        onChange={onContractCodeChange}
      />
      <SeparateItem />
      <TextField
        style={styles.mt10}
        type="outline"
        placeholder="Internal code..."
        icon="search"
        onChange={onInternalCodeChange}
      />
      <SeparateItem />
      <DatePicker
        onChange={(date: any) => {
          const val = date ? moment(date).format("YYYY-MM-DD") : null;
          updateQuery("contract_valid_from", val);
        }}
        dateFormat="yyyy-MM-dd"
        value={query?.contract_valid_from}
        showYearDropdown
        placeholderText={t().site_contract_modal__start}
      />
      <SeparateItem />
      <DatePicker
        onChange={(date: any) => {
          const val = date ? moment(date).format("YYYY-MM-DD") : null;
          updateQuery("contract_valid_to", val);
        }}
        dateFormat="yyyy-MM-dd"
        placeholderText={t().site_contract_modal__expire}
        showYearDropdown
        value={query?.contract_valid_to}
      />
      <SeparateItem />
      <TextField
        style={styles.mt10}
        type="outline"
        placeholder="Địa chỉ..."
        icon="search"
        onChange={onAddressChange}
      />
    </div>
  );
};

const styles = {
  mt10: { marginTop: 10 },
};

export default ContractFilter;
